<template>
  <div v-if="isPortalLoggedIn() && !isLoginPage" class="floating-cart" @click="goToCart">
    <el-badge :value="cartCount" :hidden="cartCount === 0" :max="99" class="cart-badge">
      <div class="cart-button">
        <el-icon :size="28" class="cart-icon">
          <ShoppingCart />
        </el-icon>
      </div>
    </el-badge>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ShoppingCart } from '@element-plus/icons-vue';
import { isPortalLoggedIn } from '@/modules/portal-auth/token';
import { useCartCount, refreshCartCount } from '@/modules/portal-auth/cart';

const router = useRouter();
const route = useRoute();
const cartCount = useCartCount();

const isLoginPage = computed(() => {
  return route.name === 'Login' || route.path === '/login';
});

// 跳转到购物车
const goToCart = () => {
  router.push('/cart');
};

// 组件挂载时刷新购物车数量
onMounted(() => {
  if (isPortalLoggedIn()) {
    refreshCartCount();
  }
});

// 暴露刷新方法给父组件
const refreshCount = async () => {
  await refreshCartCount();
};

defineExpose({ refreshCartCount: refreshCount });
</script>

<style scoped lang="scss">
.floating-cart {
  position: fixed;
  right: 40px; // 与回到顶部按钮对齐
  bottom: 150px; // 在回到顶部按钮上方70px（按钮50px + 间距20px）
  z-index: 999;
  cursor: pointer;
  animation: slideIn 0.3s ease-out;

  .cart-button {
    margin-right: -12px;
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, #b91c1c 0%, #991b1b 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 20px rgba(185, 28, 28, 0.4);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-4px) scale(1.05);
      box-shadow: 0 8px 30px rgba(185, 28, 28, 0.5);
      background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
    }

    &:active {
      transform: translateY(-2px) scale(1.02);
    }

    .cart-icon {
      color: #fff;
    }
  }

  :deep(.el-badge__content) {
    background-color: #fff;
    color: #b91c1c;
    border: 2px solid #b91c1c;
    font-size: 12px;
    font-weight: 700;

  }
}

@keyframes slideIn {
  from {
    transform: translateX(100px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .floating-cart {
    right: 20px;
    bottom: 130px; // 移动端也对齐
    bottom: calc(130px + env(safe-area-inset-bottom, 20px));

    .cart-button {
      width: 48px;
      height: 48px;
      margin-right: 0;

      .cart-icon {
        font-size: 24px;
      }
    }
    
    // 确保徽章不超出视口右边界
    :deep(.el-badge__content) {
      right: 5px;
      top: 5px;
      transform: scale(0.8);
      // 覆盖 Element Plus 默认的 translateX(50%) 防止溢出
      left: auto;
    }
  }
}
</style>
